/* Brewskin 2026 — destination pop-up. Opens from any [data-bs-locale-open]; choosing a destination on another store sends the shopper there.
   It also opens by itself, once, for visitors outside the home country: Shopify's own location check
   (/browsing_context_suggestions.json) says where they are, their country is pre-selected, and the answer (or closing the
   pop-up) is remembered on that browser. Never for bots or inside the theme editor. */
(function () {
  'use strict';
  if (window.__bsLocale) return;
  window.__bsLocale = true;
  var d = document;
  var KEY_CHOICE = 'bs-destination';          /* localStorage: the destination the shopper picked */
  var KEY_CLOSED = 'bs-destination-closed';   /* localStorage: when they closed the pop-up without picking */
  var KEY_GEO = 'bs-geo';                     /* sessionStorage: the country Shopify detected */
  var KEY_AUTO = 'bs-destination-auto';       /* sessionStorage: the pop-up already opened by itself this session */
  var CLOSED_DAYS = 30;
  var CARRY = /^(utm_|fbclid$|gclid$|gbraid$|wbraid$|ttclid$|msclkid$|igshid$|ref$)/;
  var GLOBE = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24"><rect width="32" height="24" fill="#F2ECE4"/><g fill="none" stroke="#2B1D16" stroke-width="1"><circle cx="16" cy="12" r="8"/><ellipse cx="16" cy="12" rx="3.5" ry="8"/><path d="M8 12h16M9.5 8h13M9.5 16h13"/></g></svg>');

  function dlg() { return d.querySelector('[data-bs-locale]'); }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* storage unavailable */ } }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* storage unavailable */ } }

  function sync(box) {
    var sel = box.querySelector('[data-bs-locale-select]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var flag = box.querySelector('[data-bs-locale-flag]');
    if (flag && opt) {
      var iso = (opt.value || '').toLowerCase();
      flag.style.visibility = '';
      flag.src = /^[a-z]{2}$/.test(iso) && iso !== 'ww' ? '//cdn.shopify.com/static/images/flags/' + iso + '.svg?width=48' : GLOBE;
    }
    var note = box.querySelector('[data-bs-locale-note]');
    if (note) note.hidden = !(opt && opt.getAttribute('data-url'));
  }

  /* Select the option for a country code; returns false when the list has no such option. */
  function select(box, iso) {
    var sel = box.querySelector('[data-bs-locale-select]');
    if (!sel || !iso) return false;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === iso) { sel.selectedIndex = i; return true; }
    }
    return false;
  }

  function openIt(trigger) {
    var box = dlg();
    if (!box) return;
    var ov = d.querySelector('[data-bs-ov].is-open .bs-ov__scrim');
    if (ov) ov.click();
    box.__trigger = trigger || null;
    box.__chosen = false;
    /* Opened by hand by someone who never answered: start from the country Shopify detected, if we know it. */
    if (trigger && !lsGet(KEY_CHOICE)) {
      var geo = ssGet(KEY_GEO);
      if (geo && geo !== box.getAttribute('data-bs-locale-home')) { if (!select(box, geo)) select(box, 'WW'); }
    }
    sync(box);
    if (typeof box.showModal === 'function') { if (!box.open) box.showModal(); }
    else box.setAttribute('open', '');
  }

  function closeIt() {
    var box = dlg();
    if (!box) return;
    if (typeof box.close === 'function' && box.open) box.close();
    else box.removeAttribute('open');
  }

  /* Where a destination link should go. A bare store address becomes the same product there when the shopper is on a
     product page; the ad's tracking tags (utm_*, fbclid and the like) come along either way. Anything unexpected: the link as is. */
  function target(url) {
    try {
      var u = new URL(url, window.location.href);
      var m = window.location.pathname.replace(/\/+$/, '').match(/\/products\/([^\/?#]+)$/);
      if (u.pathname === '/' && m) u.pathname = '/products/' + m[1];
      new URLSearchParams(window.location.search).forEach(function (v, k) {
        if (CARRY.test(k) && !u.searchParams.has(k)) u.searchParams.append(k, v);
      });
      return u.href;
    } catch (e) { return url; }
  }

  /* Change the shopping country on this store, the same way Shopify's own localization form does. The page reloads once. */
  function switchCountry(iso) {
    var f = d.createElement('form');
    f.method = 'post';
    f.action = root() + 'localization';
    f.hidden = true;
    var add = function (n, v) { var i = d.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i); };
    add('form_type', 'localization');
    add('utf8', '\u2713');
    add('_method', 'put');
    add('country_code', iso);
    add('return_to', window.location.pathname + window.location.search);
    d.body.appendChild(f);
    f.submit();
  }

  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-bs-locale-open]');
    if (t) { e.preventDefault(); openIt(t); return; }
    if (e.target.closest('[data-bs-locale-close]')) { e.preventDefault(); closeIt(); return; }
    var box = dlg();
    if (box && e.target === box) closeIt(); /* click on the backdrop */
  });

  d.addEventListener('change', function (e) {
    if (e.target.matches('[data-bs-locale-select]')) sync(e.target.closest('[data-bs-locale]'));
  });

  d.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-bs-locale-form]')) return;
    e.preventDefault();
    var box = e.target.closest('[data-bs-locale]');
    var sel = box.querySelector('[data-bs-locale-select]');
    var opt = sel && sel.options[sel.selectedIndex];
    var iso = opt ? (opt.value || '') : '';
    var url = opt && opt.getAttribute('data-url');
    box.__chosen = true;
    lsSet(KEY_CHOICE, iso);
    if (url) { window.location.href = target(url); return; }
    var current = (window.Shopify && window.Shopify.country) || '';
    if (opt && opt.hasAttribute('data-market') && current && current !== iso) { switchCountry(iso); return; }
    closeIt();
  });

  d.addEventListener('close', function (e) {
    var box = e.target;
    if (!box || !box.matches || !box.matches('[data-bs-locale]')) return;
    if (!box.__chosen) lsSet(KEY_CLOSED, String(Date.now()));
    box.__chosen = false;
    if (box.__trigger && box.__trigger.isConnected) box.__trigger.focus();
  }, true);

  d.addEventListener('error', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-bs-locale-flag]')) e.target.src = GLOBE;
  }, true);

  /* ---------- Opening by itself ---------- */
  function isBot() { return /bot|crawl|spider|slurp|lighthouse|headless|facebookexternalhit|whatsapp|telegram|pingdom|gtmetrix/i.test(navigator.userAgent || ''); }
  function closedRecently() {
    var t = Number(lsGet(KEY_CLOSED));
    return !!t && (Date.now() - t) < CLOSED_DAYS * 864e5;
  }
  function fromIntlStore(box) {
    var intl = box.getAttribute('data-bs-locale-intl');
    if (!intl || !d.referrer) return false;
    try { return new URL(d.referrer).host === new URL(intl, window.location.href).host; } catch (e) { return false; }
  }
  /* The country Shopify detects from the visitor's connection; falls back to the country they are already browsing in. */
  function detect() {
    var cached = ssGet(KEY_GEO);
    if (cached) return Promise.resolve(cached);
    var fallback = ((window.Shopify && window.Shopify.country) || '').toUpperCase();
    if (typeof fetch !== 'function') return Promise.resolve(fallback);
    return fetch(root() + 'browsing_context_suggestions.json?country[enabled]=true', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var cc = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        cc = (cc || fallback || '').toUpperCase();
        if (cc) ssSet(KEY_GEO, cc);
        return cc;
      })
      .catch(function () { return fallback; });
  }
  function auto() {
    var box = dlg();
    if (!box) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (isBot() || lsGet(KEY_CHOICE) || closedRecently() || ssGet(KEY_AUTO) || fromIntlStore(box)) return;
    var home = (box.getAttribute('data-bs-locale-home') || 'IN').toUpperCase();
    detect().then(function (cc) {
      if (!cc || cc === home) return;
      box = dlg();
      if (!box || box.open) return;
      ssSet(KEY_AUTO, '1');
      if (!select(box, cc)) select(box, 'WW');
      setTimeout(function () { if (!box.open) openIt(null); }, 600);
    });
  }
  if (d.readyState === 'complete') auto();
  else window.addEventListener('load', auto);
})();
